import React, { useMemo } from "react";
import useCoordinatesMap from "../../../../../common-deprecated/hooks/useCoordinatesMap";
import Preloader from "../../../../../common-deprecated/styles/toyota/Preloader";
import Map from "./CoordinatesMap.styles";

type PropsType = {
    lat: number;
    lon: number;
    zoom: number;
    type: "static" | "dynamic";
};

const CoordinatesMap = (props: PropsType): JSX.Element => {
    const { mapContainer, mapInitialized } = useCoordinatesMap(props);

    // Only rerender when the preloader is toggled. Anything else should happen within the mapbox wrapper.
    return useMemo(
        () => (
            <>
                <Map ref={mapContainer} />
                {!mapInitialized && <Preloader />}
            </>
        ),
        [mapInitialized],
    );
};

export default CoordinatesMap;
